import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import '@mcity/siauliai-core/src/lng'

const rootEl = document.getElementById('root')
ReactDOM.render(<App />, rootEl)
